import {
    SYSTEM_CHOOSE_CURRENT_BENEFITS,
} from './constants';
  
export function chooseCurrentBenefits(modal) {
    return {
      type: SYSTEM_CHOOSE_CURRENT_BENEFITS,
      data: modal,
    };
}
  
export function reducer(state, action) {
    switch (action.type) {
      case SYSTEM_CHOOSE_CURRENT_BENEFITS:
        return {
          ...state,
          currentBenefits:action.data,
        };
  
      default:
        return state;
    }
}


// WEBPACK FOOTER //
// ./src/features/system/redux/chooseCurrentBenefits.js